import { action, get } from "@ember/object"
import Component from "@glimmer/component"
import type {
  Card,
  CardGoogleClassroom,
  LegacyCardStackUsedAsTypes,
} from "@shared/models/card-stack"
import type { GoogleClassPostStatus } from "@shared/models/google-classroom"
import type { Permission } from "@shared/models/permissions"
import FindDocument from "cc-frontend/helpers/find-doc"
import type { RegisterCardAiValueEditor } from "cc-frontend/lib/ai/ai-value-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import { use } from "ember-could-get-used-to-this"
import { filter } from "lodash-es"
import styles from "./card-google-classroom.module.css"

interface Signature {
  Args: {
    openGoogleClassroomPostSidebar: (card: Card) => void
    hideMoveButton: boolean
    card: CardGoogleClassroom
    usedAs: LegacyCardStackUsedAsTypes
    cardStackId: string
    permissions: Array<Permission>
    modelsNeededForFirstEdit: ModelsNeededForFirstEdit
    registerCardEditor?: RegisterCardAiValueEditor
    onMouseLeave: () => void
  }
}

export default class CardGoogleClassroomComponent extends Component<Signature> {
  readonly styles = styles

  @use mediator = new FindDocument(() => ["google-classroom-card-mediator", this.args.card.id])

  @action triggerGoogleClassroomSidebar(card: Card, _event: Event) {
    if (card.type === "card-google-classroom" && this.args.usedAs === "lesson") {
      this.args.onMouseLeave()
      this.args.openGoogleClassroomPostSidebar(card)
    }
  }

  get publishedCourses() {
    return filter(
      // @ts-ignore
      get(this, "mediator.content.attributes.googleClassStatuses"),
      (classStatus: GoogleClassPostStatus) => {
        return classStatus.status == "PUBLISHED"
      },
    )
  }

  get scheduledCourses() {
    return filter(
      // @ts-ignore
      get(this, "mediator.content.attributes.googleClassStatuses"),
      (classStatus: GoogleClassPostStatus) => {
        return classStatus.status == "SCHEDULED"
      },
    )
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::CardStacks::Cards::CardGoogleClassroom": typeof CardGoogleClassroomComponent
  }
}
